<style scoped>
.btn_shadow_half {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 2px 2px 5px #838383, -2px -2px 5px #ffffff !important;
}

.headline {
  background-color: #1b2643;
  width: 100%;
  height: 60px;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.active_text {
  border-bottom: 2px solid #ffffff;
  height: 60px;
}

.headline p {
  color: #ffffff;
  font-size: 14px;
}
td {
  border-bottom: 1px solid #dbdbdb;
}

.result_title {
  max-height: 10px;
}

/* 追加 */
.v-input {
  font-size: 14px;
}
.select {
  margin-left: 30px;
  margin-bottom: 7px;
  height: 10px;
}

.DLbtn {
  width: 4rem;
}

.highlight-row,
.highlight-row td {
  background-color: #fff3cd !important;
  transition: background-color 0.5s ease;
}
</style>

<template>
  <!-- Main Campaign Management Section -->
  <div>
    <!-- Campaign Search Card -->
    <div v-show="!isShowComponent">
      <div class="pa-3 headline">
        <p>{{ $t('home.campaigns') }}</p>
      </div>
      <div class="content px-10 pt-10">
        <v-form ref="form" lazy-validation @submit.prevent>
          <v-row class="ml-1 mr-10 mb-n8 text-body-2">
            <p v-html="$t('home.campaignSearchScreen')"></p>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field
                class="v-input"
                v-model="filterExam"
                append-icon="mdi-magnify"
                :label="$t('home.searchQueryPlaceholder')"
                single-lin5
                hide-details
                @keypress.enter="searchCampaign"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                class="ma-2 mb-5 btn_shadow_half"
                color="#1b2643"
                dark
                @click="searchCampaign"
              >
                {{ $t('home.search') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mr-10 mb-4 text-body-2">
            <v-btn @click="isShowFilter = !isShowFilter" text
              >{{ $t('home.option.searchOption') }}
              <v-icon v-if="!isShowFilter">mdi-menu-right</v-icon>
              <v-icon v-else>mdi-menu-down</v-icon>
            </v-btn>
          </v-row>
          <v-row v-if="isShowFilter">
            <v-col class="d-flex" cols="8">
              <v-select
                v-model="searchFor"
                :items="[
                  {
                    text: $t(
                      'home.stringSearchOptions.searchByCampaignCodeOrName'
                    ),
                    value: 'searchByCampaignCodeOrName',
                  },
                  {
                    text: $t('home.stringSearchOptions.searchByCampaignCode'),
                    value: 'searchByCampaignCode',
                  },
                  {
                    text: $t('home.stringSearchOptions.searchByCampaignName'),
                    value: 'searchByCampaignName',
                  },
                ]"
                :label="$t('home.option.searchStringTarget')"
                dense
                class="select"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="isShowFilter">
            <v-col class="d-flex" cols="4">
              <v-select
                v-model="filterByPublicationPeriod"
                :items="[
                  {
                    text: $t('home.publicationPeriodFilterOption.noFilter'),
                    value: 'noFilter',
                  },
                  {
                    text: $t(
                      'home.publicationPeriodFilterOption.beforePublicationPeriod'
                    ),
                    value: 'beforePublicationPeriod',
                  },
                  {
                    text: $t(
                      'home.publicationPeriodFilterOption.duringPublicationPeriod'
                    ),
                    value: 'duringPublicationPeriod',
                  },
                  {
                    text: $t(
                      'home.publicationPeriodFilterOption.afterPublicationPeriod'
                    ),
                    value: 'afterPublicationPeriod',
                  },
                  {
                    text: $t(
                      'home.publicationPeriodFilterOption.specifyPublicationPeriod'
                    ),
                    value: 'specifyPublicationPeriod',
                  },
                ]"
                :label="$t('home.option.publicationPeriodFilter')"
                dense
                @change="onPublicationPeriodChange"
                class="select"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            class="ml-10"
            v-if="
              isShowFilter &&
              filterByPublicationPeriod === 'specifyPublicationPeriod'
            "
          >
            <v-col cols="5">
              <set-schedule
                :cardTitle="String($t('home.timeSetting.startDate'))"
                @changeDateTime="filterByOpenTime = $event"
              />
            </v-col>
            <v-col cols="5">
              <set-schedule
                :cardTitle="String($t('home.timeSetting.endDate'))"
                @changeDateTime="filterByClosedTime = $event"
              />
            </v-col>
          </v-row>
          <v-row class="mb-4" v-if="isShowFilter">
            <v-col class="d-flex" cols="4">
              <v-select
                v-model="filterByExamPeriod"
                :items="[
                  {
                    text: $t('home.examinationPeriodFilterOption.noFilter'),
                    value: 'noFilter',
                  },
                  {
                    text: $t(
                      'home.examinationPeriodFilterOption.beforeInterviewPeriod'
                    ),
                    value: 'beforeInterviewPeriod',
                  },
                  {
                    text: $t(
                      'home.examinationPeriodFilterOption.duringInterviewPeriod'
                    ),
                    value: 'duringInterviewPeriod',
                  },
                  {
                    text: $t(
                      'home.examinationPeriodFilterOption.afterInterviewPeriod'
                    ),
                    value: 'afterInterviewPeriod',
                  },
                  {
                    text: $t(
                      'home.examinationPeriodFilterOption.specifyInterviewPeriod'
                    ),
                    value: 'specifyInterviewPeriod',
                  },
                ]"
                :label="$t('home.option.examinationPeriodFilter')"
                dense
                @change="onExamPeriodChange"
                class="select"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            class="ml-10"
            v-if="
              isShowFilter && filterByExamPeriod === 'specifyInterviewPeriod'
            "
          >
            <v-col cols="5">
              <set-schedule
                :cardTitle="String($t('home.timeSetting.startDate'))"
                @changeDateTime="filterByStartTime = $event"
              />
            </v-col>
            <v-col cols="5">
              <set-schedule
                :cardTitle="String($t('home.timeSetting.endDate'))"
                @changeDateTime="filterByEndTime = $event"
              />
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>

    <!-- Campaign Results Table -->
    <div v-show="!isShowComponent">
      <div class="content px-10">
        <template v-if="$store.getters.isLoadingUser || isLoadingCampaigns">
        <v-progress-linear indeterminate></v-progress-linear>
        <p class="w-full text-center primary--text text-caption">
          {{
            isLoadingCampaigns
              ? $t('home.progress.loadingCampaigns')
              : $t('home.progress.loadingCouponCounts')
          }}
        </p>
      </template>
      <v-form ref="form">
        <div class="pt-5">
          <v-row class="ml-5 mr-10 mt-3 mb-n8 text-body-2">
            <p>
              {{
                $t('home.displayCampaign', {
                  totalCampaigns: campaignNum,
                  displayedCampaigns: isShowCampaignNum,
                })
              }}
            </p>
          </v-row>
          <v-row
            v-if="searched && filterExamString"
            class="ml-10 mr-10 text-body-2"
          >
            {{ $t('home.searchquery') }}
            {{
              $t('home.filterCampaign', {
                filterCampaigns: filterExamString,
                searchByCampaignCodeOrName: $t(
                  `home.stringSearchOptions.${searchFor}`
                ),
              })
            }}
          </v-row>
          <v-row
            v-if="publicationPeriodLabel || examPeriodLabel"
            class="ml-10 mr-10 text-body-2"
          >
            {{ $t('home.filter') }}
            {{ publicationPeriodLabel }}
            {{ publicationPeriodLabel && examPeriodLabel ? '&' : '' }}
            {{ examPeriodLabel }}
          </v-row>
          <v-row>
            <v-col cols="12" class="px-0">
              <v-data-table
                :headers="headers"
                :items="campaignData"
                item-key="campaignCode"
                :items-per-page="-1"
                :disable-pagination="true"
                :hide-default-footer="true"
                :options="options"
                :group-by="groupBy"
              >
                <template
                  v-slot:[`group.header`]="{ group, toggle, isOpen, items }"
                >
                  <template
                    v-if="
                      group !== '' && group !== 'null' && group !== '\u{10FFFF}'
                    "
                  >
                    <td
                      colspan="6"
                      class="text-start font-weight-bold"
                      :data-package-id="items[0].packageId"
                    >
                      <v-btn icon small @click="toggle()">
                        <v-icon>{{
                          isOpen ? 'mdi-menu-down' : 'mdi-menu-right'
                        }}</v-icon>
                      </v-btn>
                      <v-icon left>{{
                        isOpen
                          ? 'mdi-package-variant'
                          : 'mdi-package-variant-closed'
                      }}</v-icon
                      >{{ group
                      }}<v-chip small class="ml-2">
                        {{ getShowingCampaignCount(items) }}</v-chip
                      >
                    </td>

                    <td>
                      <router-link
                        :to="`/dashboard/package/edit/${items[0].packageId}`"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </router-link>
                    </td>
                    <td>
                      <v-icon
                        small
                        class="mr-2"
                        @click="openPackageCouponList(items[0].packageId)"
                        >mdi-list-box-outline</v-icon
                      >
                    </td>
                    <td>
                      <router-link
                        :to="`/dashboard/package-results/${
                          packageData[items[0].packageId].code
                        }`"
                      >
                        <v-icon small>mdi-file-search-outline</v-icon>
                      </router-link>
                    </td>
                    <td>
                      <v-icon
                        small
                        class="mr-2"
                        @click="openDistributionDialog(items[0].packageId)"
                        >mdi-share-variant</v-icon
                      >
                    </td>
                    <td></td>
                  </template>
                  <template v-else>
                    <td colspan="12" class="text-start font-weight-bold">
                      {{ $t('home.individualCampaign')
                      }}<v-chip small class="ml-2">
                        {{ getShowingCampaignCount(items) }}</v-chip
                      >
                    </td>
                  </template>
                </template>
                <template v-slot:[`header.campaignCode`]="{ header }">
                  <th class="d-flex text-start" v-html="header.text"></th>
                </template>
                <template v-slot:[`header.couponCounts`]="{ header }">
                  <th class="d-flex text-start" v-html="header.text"></th>
                </template>
                <template v-slot:item="{ item }">
                  <tr
                    v-show="item.isShow"
                    :data-campaign-code="item.campaignCode"
                  >
                    <td>{{ item.packageId ? item.packageIndex + 1 : '' }}</td>
                    <td :style="{ color: item.isDynamic ? '#e2d06e' : '' }">
                      <b>{{ item.campaignName }}</b
                      ><br />
                      ({{ item.campaignCode }})
                    </td>
                    <td :style="{ color: item.isDynamic ? '#e2d06e' : '' }">
                      {{ UnixTimeToString(item.openTime) }} ~
                      {{ UnixTimeToString(item.closedTime) }}
                    </td>
                    <td :style="{ color: item.isDynamic ? '#e2d06e' : '' }">
                      {{ UnixTimeToString(item.startTime) }} ~
                      {{ UnixTimeToString(item.endTime) }}
                    </td>
                    <td :style="{ color: item.isDynamic ? '#e2d06e' : '' }">
                      {{ item.couponNum }}&nbsp;/&nbsp;{{
                        item.confirmedCouponCount
                      }}
                    </td>
                    <td :style="{ color: item.isDynamic ? '#e2d06e' : '' }">
                      <span v-if="item.isUnlimited">{{
                        $t('campaignSetting.interviewCountOption.unlimited')
                      }}</span>
                      <span v-else
                        >{{ item.limits }}
                        {{ $t('campaignSetting.time') }}</span
                      >
                    </td>
                    <td>
                      <v-icon
                        v-show="!item.packageId"
                        small
                        class="mr-2"
                        @click="editItem(item)"
                      >
                        mdi-pencil
                      </v-icon>
                    </td>
                    <td>
                      <v-icon
                        v-show="!item.packageId"
                        small
                        class="mr-2"
                        @click="openCampaignCouponList(item.campaignId)"
                        >mdi-list-box-outline</v-icon
                      >
                    </td>
                    <td>
                      <router-link
                        :to="`/dashboard/campaign-results/${item.campaignCode}`"
                      >
                        <v-icon small>mdi-file-search-outline</v-icon>
                      </router-link>
                    </td>
                    <td></td>
                    <td>
                      <v-btn
                        :disabled="item.isProcessing"
                        class="btn_shadow_half"
                        color="#1b2643"
                        dark
                        @click="downloadBtnAction(item.campaignId)"
                        v-show="!item.isDownloading"
                        small
                      >
                        <v-icon small left color="white"
                          >mdi-folder-zip-outline</v-icon
                        >
                        DL
                      </v-btn>
                      <v-btn
                        disabled
                        class="DLbtn"
                        color="white"
                        v-show="item.isDownloading"
                        small
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          size="18"
                        ></v-progress-circular>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-form>

      <v-form>
        <div>
          <snack-bar
            :snackbarAction="snackbarActionBtn"
            :snackbarText="snackbarTextField"
            :snackbarColor="snackbarColorField"
            :actionButtonText="snackbarActionButtonText"
            :actionButtonRoute="snackbarActionButtonRoute"
            @closeSnackbar="closeSnackbar"
            @actionButtonClick="onSnackbarActionButtonClick"
          />
        </div>
      </v-form>
      </div>
    </div>

    <set-exam
      v-show="isShowComponent"
      :campaignId="editedItem.campaignId"
      :campaignCode="editedItem.campaignCode"
      :campaignName="editedItem.campaignName"
      :openTime="editedItem.openTime"
      :closedTime="editedItem.closedTime"
      :startTime="editedItem.startTime"
      :endTime="editedItem.endTime"
      :isUnlimited="editedItem.isUnlimited"
      :limits="String(editedItem.limits)"
      :isDynamicCampaign="editedItem.isDynamic"
      :couponNum="editedItem.couponNum"
      :scenarioDocId="editedItem.scenarioDocId"
      :hasCouponError="editItemHasCouponError"
      @closeComponent="resetComponent"
      @deleteItem="deleteItem"
    />

    <!-- Coupon Management Dialog -->
    <coupon-list-dialog
      v-if="isCouponDialogVisible"
      :isVisible.sync="isCouponDialogVisible"
      :type="couponDialogCollection"
      :id="couponDialogId"
      @change="handleCouponListChange($event)"
    />

    <!-- Distribution Dialog -->
    <distribution-dialog
      v-if="isDistributionDialogVisible"
      :isVisible.sync="isDistributionDialogVisible"
      :package="distributionPackage"
      @see-tickets="handleDistributionSeeTickets($event)"
    />
  </div>
</template>

<script lang="ts">
// Components
import { defineComponent } from "@vue/composition-api";
import moment from "moment-timezone";
// Services
import { campaignService } from "@/api/campaignService";
import { packageService } from "@/api/packageService";
import CouponListDialog from "@/components/Dashboard/Dialogs/CouponListDialog.vue";
import DistributionDialog from "@/components/Dashboard/Dialogs/DistributionDialog/index.vue";
import SetExam from "@/components/Dashboard/PageViewItems/SetExamCardComponent.vue";
import SetSchedule from "@/components/Dashboard/PageViewItems/SetScheduleComponent.vue";
import SnackBar from "@/components/Dashboard/PageViewItems/SnackbarComponent.vue";
import { roundToTwoDecimals } from "@/components/utils/commonUtils";
import { getJstTimestamp } from "@/components/utils/dateUtils";
// Types
import type { CampaignWithId, HomeCampaignType } from "@/resources/campaign";
import type {
  CategoryWithDescription,
  CefrResults,
  DialogWithRelations,
} from "@/resources/dialog";
import type { PackageWithId } from "@/resources/package";
import type { TableHeader } from "@/resources/table";
import type { DateOrTimestamp } from "@/resources/utils";
// Utilities
import store from "@/store";
import {
  createCsvContent,
  downloadCsv,
  downloadNoDialogAssessmentCsv,
  forceCsvText,
} from "@/utils";
import {
  getCanDoScores,
  getReviewPracticeCount,
} from "@/utils/transformCampaignResult";

type PackageType = {
  [packageId: string]: {
    code: string;
    name: string;
    campaignIds: string[];
  };
};

/**
 * Main dashboard component for campaign management
 * Handles campaign listing, filtering, and coupon management
 */
export default defineComponent({
  name: "HomeView",

  components: {
    SetExam,
    SnackBar,
    SetSchedule,
    CouponListDialog,
    DistributionDialog,
  },

  // Component data properties organized by feature
  data() {
    return {
      // Campaign Search & Filter Properties
      filterExam: "",
      filterExamString: "",
      filterByPeriod: "all",
      filterByPublicationPeriod: "all",
      filterByExamPeriod: "all",
      searchFor: "all",
      isShowFilter: false,
      filterByPublicationPeriodString: "",
      filterByExamPeriodString: "",
      searchForString: "",
      searched: false,
      filterByOpenTime: 0,
      filterByClosedTime: 0,
      filterByStartTime: 0,
      filterByEndTime: 0,

      // Campaign Data Properties
      campaignInfo: false,
      campaignNum: 0,
      isShowCampaignNum: 0,
      isShowComponent: false,

      isLoadingCampaigns: false,
      campaignData: [] as HomeCampaignType[],
      packageData: {} as PackageType,
      rawPackages: [] as PackageWithId[],

      // Campaign Edit Properties
      editedIndex: -1,
      editedItem: {} as HomeCampaignType,

      // Notification Properties
      snackbarActionBtn: false,
      snackbarTextField: "",
      snackbarColorField: "",
      snackbarActionButtonText: "",
      snackbarActionButtonRoute: "",
      snackbarScrollToSelector: "",
      snackbarEditCampaignCode: "",

      // Results Properties
      headers: [] as TableHeader[],
      options: {
        sortBy: ["packageIndex", "openTime"],
        sortDesc: [false, false],
      },
      groupBy: "packageCode",

      // Coupon Dialog Properties
      isCouponDialogVisible: false,
      couponDialogCollection: null as null | "campaigns" | "packages",
      couponDialogId: "" as null | string,

      // Distribution Dialog Properties
      distributionPackage: null as null | PackageWithId,
      isDistributionDialogVisible: false,

      // Edit context — set when arriving via coupon failure snackbar
      editItemHasCouponError: false,
    };
  },

  props: {
    snackbarAction: { type: Boolean, default: false },
    snackbarText: { type: String, default: "" },
    snackbarColor: { type: String, default: "" },
  },

  // 画面ロード時の認証とデータ取得
  async created() {
    this.initialize();
    this.updateHeaders();
  },

  async mounted() {
    await this.waitForUserDataAndLoadData();

    this.$root.$on("showSnackbar", this.showSnackbar);
  },

  beforeDestroy() {
    this.$root.$off("showSnackbar", this.showSnackbar);
  },

  watch: {
    "$i18n.locale": function () {
      this.updateHeaders();
    },
    isCouponDialogVisible(val: boolean) {
      if (!val) {
        this.resetCouponDialogState();
      }
    },
    // Watch for changes in customerId in case it gets set after component mount
    // or when a different user signs in
    "$store.state.customerId": function (newCustomerId, oldCustomerId) {
      // If customerId changed from one user to another, always reload data
      // to prevent stale data from previous user
      if (newCustomerId && newCustomerId !== oldCustomerId) {
        console.info(
          "[HomeView] Customer ID changed, reloading data",
          `${oldCustomerId} -> ${newCustomerId}`,
        );
        this.readData();
      }
    },
  },
  computed: {
    publicationPeriodLabel(): string {
      return this.getPeriodLabel(
        this.filterByPublicationPeriod,
        "specifyPublicationPeriod",
        this.filterByOpenTime,
        this.filterByClosedTime,
        "home.publicationPeriodFilterOption",
      );
    },
    examPeriodLabel(): string {
      return this.getPeriodLabel(
        this.filterByExamPeriod,
        "specifyInterviewPeriod",
        this.filterByStartTime,
        this.filterByEndTime,
        "home.examinationPeriodFilterOption",
      );
    },
  },
  methods: {
    /**
     * Component Lifecycle Methods
     */
    async waitForUserDataAndLoadData() {
      // Wait for user data to be loaded
      if (this.$store.getters.isLoadingUser) {
        // Create a promise that resolves when loading is complete
        await new Promise<void>((resolve) => {
          const unwatch = this.$store.watch(
            (state) => state.isLoadingUser,
            (isLoading) => {
              if (!isLoading) {
                unwatch();
                resolve();
              }
            },
          );
        });
      }

      // Load data after user data is available
      await this.readData();
    },

    initialize() {
      const params = this.$route.params;
      this.snackbarActionBtn = params.snackbarAction === "true";
      this.snackbarTextField = params.snackbarText || "";
      this.snackbarColorField = params.snackbarColor || "";
      this.snackbarActionButtonText = params.snackbarActionButtonText || "";
      this.snackbarActionButtonRoute = params.snackbarActionButtonRoute || "";
      this.snackbarScrollToSelector = params.snackbarScrollToSelector || "";
      this.snackbarEditCampaignCode = params.snackbarEditCampaignCode || "";
    },

    getCefrLabel(cefrItem: CategoryWithDescription | undefined): string {
      if (!cefrItem) return "";
      return cefrItem.cefrLevel || cefrItem.label || "";
    },

    async resetComponent(emittedText: string) {
      this.isShowComponent = false;
      this.editItemHasCouponError = false;
      if (emittedText) {
        this.snackbarActionBtn = true;
        this.snackbarTextField = emittedText;
        this.snackbarColorField = "pink";
      }
      await this.readData();
    },

    /**
     * Campaign Management Methods
     */
    editItem(item: HomeCampaignType) {
      this.editedIndex = this.campaignData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.isShowComponent = true;
      // 以下画面遷移時のフィルタに関する不具合修正のための初期化
      // 急ピッチでの修正なのでもう少し良い形にしたい
      // Reset filter state when transitioning screens
      this.filterExamString = "";
      this.searchFor = "";
      this.searchForString = "";
      this.filterByExamPeriod = "";
      this.filterByExamPeriodString = "";
      this.filterByPublicationPeriod = "";
      this.filterByPublicationPeriodString = "";
    },
    // テスト削除ボタンコンポーネントで「削除」ボタンを押した際に呼び出される関数
    deleteItem() {
      this.$router.go(0);
      this.campaignData.splice(this.editedIndex, 1);
      this.editedIndex = -1;
      this.editedItem = {
        customerCode: "",
        customerId: "",
        campaignId: "",
        campaignCode: "",
        campaignName: "",
        category: "",
        openTime: 0,
        closedTime: 0,
        startTime: 0,
        endTime: 0,
        couponNum: 0,
        confirmedCouponCount: 0,
        isShow: true,
        isUnlimited: false,
        isDownloading: false,
        isProcessing: false,
        limits: 0,
        scenarioDocId: "",
        systemInfo: {
          intella: {
            version: "",
          },
          gnowsis: {
            modelVersion: "",
            systemVersion: "",
          },
        },
        packageCode: "",
        packageId: "",
        packageIndex: 0,
      };
      this.isShowComponent = false;
      this.snackbarActionBtn = true;
      this.snackbarTextField = "削除しました";
      this.snackbarColorField = "pink";
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.campaignData[this.editedIndex], this.editedItem);
      } else {
        this.campaignData.push(this.editedItem);
      }
    },

    /**
     * Campaign Search and Filter Methods
     */
    searchCampaign() {
      this.isShowCampaignNum = 0; //検索の結果表示されるキャンペーンの数を初期化
      this.searched = true; //検索を実行したか否か
      this.filterExamString = this.filterExam; //検索語を格納（即時に反映されるのを防ぐために別の変数を使用）
      for (let i = 0; i < this.campaignData.length; i++) {
        let campaign = ""; //文字列検索の対象となる文字列を格納するための変数
        this.campaignData[i]["isShow"] = true;
        // 文字列検索

        if (this.searchFor === "searchByCampaignCode") {
          campaign = this.campaignData[i]["campaignCode"];
          this.searchForString = this.$t("home.campaignCode") as string;
        } else if (this.searchFor === "searchByCampaignName") {
          campaign = this.campaignData[i]["campaignName"];
          this.searchForString = this.$t("home.campaignName") as string;
        } else {
          campaign =
            this.campaignData[i]["campaignName"] +
            this.campaignData[i]["campaignCode"];
          this.searchForString = this.$t("home.campaignCodeOrName") as string;
        }
        if (campaign.indexOf(this.filterExamString) === -1) {
          this.campaignData[i]["isShow"] = false;
        }

        // 現在時刻の取得
        const presentTime = new Date(
          moment().tz("Asia/Tokyo").format(),
        ).getTime();

        // 公開期間フィルタ
        this.filterByPublicationPeriodString = `${this.$t(
          `home.publicationPeriodFilterOption.${this.filterByPublicationPeriod}`,
        )}`;

        if (this.filterByPublicationPeriod === "beforePublicationPeriod") {
          if (presentTime > this.campaignData[i]["openTime"]) {
            this.campaignData[i]["isShow"] = false;
          }
        } else if (
          this.filterByPublicationPeriod === "duringPublicationPeriod"
        ) {
          if (
            presentTime < this.campaignData[i]["openTime"] ||
            presentTime > this.campaignData[i]["closedTime"]
          ) {
            this.campaignData[i]["isShow"] = false;
          }
        } else if (
          this.filterByPublicationPeriod === "afterPublicationPeriod"
        ) {
          if (presentTime < this.campaignData[i]["closedTime"]) {
            this.campaignData[i]["isShow"] = false;
          }
        } else if (
          this.filterByPublicationPeriod === "specifyPublicationPeriod" &&
          (this.filterByOpenTime !== 0 || this.filterByClosedTime !== 0)
        ) {
          if (
            this.filterByClosedTime < this.campaignData[i]["openTime"] ||
            this.filterByOpenTime > this.campaignData[i]["closedTime"]
          ) {
            this.campaignData[i]["isShow"] = false;
          }
          this.filterByPublicationPeriodString = `${this.$t(
            "home.publicationPeriodFilterOption.specifyPublicationPeriod",
          )}（${this.UnixTimeToString(
            this.filterByOpenTime,
          )}) 〜 (${this.UnixTimeToString(this.filterByClosedTime)})`;
        } else {
          this.filterByPublicationPeriodString = "";
        }

        // 受験期間フィルタ
        this.filterByExamPeriodString = `${this.$t(
          `home.examinationPeriodFilterOption.${this.filterByExamPeriod}`,
        )}`;
        if (this.filterByExamPeriod === "beforeInterviewPeriod") {
          if (presentTime > this.campaignData[i]["startTime"]) {
            this.campaignData[i]["isShow"] = false;
          }
        } else if (this.filterByExamPeriod === "duringInterviewPeriod") {
          if (
            presentTime < this.campaignData[i]["startTime"] ||
            presentTime > this.campaignData[i]["endTime"]
          ) {
            this.campaignData[i]["isShow"] = false;
          }
        } else if (this.filterByExamPeriod === "afterInterviewPeriod") {
          if (presentTime < this.campaignData[i]["endTime"]) {
            this.campaignData[i]["isShow"] = false;
          }
        } else if (
          this.filterByExamPeriod === "specifyInterviewPeriod" &&
          (this.filterByStartTime !== 0 || this.filterByEndTime !== 0)
        ) {
          if (
            this.filterByEndTime < this.campaignData[i]["startTime"] ||
            this.filterByStartTime > this.campaignData[i]["endTime"]
          ) {
            this.campaignData[i]["isShow"] = false;
          }
          this.filterByExamPeriodString = `${this.$t(
            "home.examinationPeriodFilterOption.specifyInterviewPeriod",
          )} (${this.UnixTimeToString(
            this.filterByStartTime,
          )}) 〜 (${this.UnixTimeToString(this.filterByEndTime)})`;
        } else {
          this.filterByExamPeriodString = "";
        }

        // 表示数のカウント
        if (this.campaignData[i]["isShow"]) {
          this.isShowCampaignNum++;
        }
      }
    },

    onPublicationPeriodChange() {
      if (this.filterByPublicationPeriod === "specifyPublicationPeriod") {
        const now = moment().startOf("day").toDate();
        const timestamp = now.getTime(); // UNIX timestamp in ms
        this.filterByOpenTime = timestamp;
        this.filterByClosedTime = timestamp;
      } else {
        this.filterByOpenTime = 0;
        this.filterByClosedTime = 0;
      }
    },

    onExamPeriodChange() {
      if (this.filterByExamPeriod === "specifyInterviewPeriod") {
        const now = moment().startOf("day").toDate();
        const timestamp = now.getTime();
        this.filterByStartTime = timestamp;
        this.filterByEndTime = timestamp;
      } else {
        this.filterByStartTime = 0;
        this.filterByEndTime = 0;
      }
    },

    /**
     * Data Loading and Management Methods
     */
    async readData() {
      this.campaignData = [];
      this.campaignNum = 0;
      this.isShowCampaignNum = 0;
      this.isLoadingCampaigns = true;
      await this.loadCampaignList();
      this.isLoadingCampaigns = false;
    },

    async loadCampaignList() {
      const customerId = store.state.customerId;
      if (!customerId) {
        console.warn(
          "[HomeView] No customerId available, skipping campaign load",
        );
        return;
      }

      const campaigns = await campaignService.list({
        cu: customerId,
        sortOrder: "asc",
        sortBy: "openAt",
      });
      const packages = await packageService.list({
        cu: customerId,
        sortOrder: "asc",
        sortBy: "name",
      });

      this.rawPackages = packages;

      await this.mapPackages(packages);
      await this.fixCampaignlessPackages();
      await this.mapCampaigns(campaigns);
      await this.loadConfirmedCouponCount();
    },

    async mapPackages(packages: PackageWithId[]) {
      this.packageData = packages.reduce((acc, p) => {
        acc[p.id] = {
          code: p.code,
          name: p.name,
          campaignIds: p.campaignIds,
        };
        return acc;
      }, {} as PackageType);
    },

    mapCampaigns(campaigns: CampaignWithId[]) {
      for (const campaign of campaigns) {
        const campaignId = campaign.id;

        const packageId = campaign.packageId;
        const packageData = packageId ? this.packageData[packageId] : undefined;
        const packageCode = this.getPackageCode(packageData);
        const packageIndex = this.getPackageIndex(campaignId, packageData);

        this.campaignNum++;
        this.isShowCampaignNum++;

        this.campaignData.push({
          customerId: campaign.customerId,
          customerCode: campaign.customerCode,
          campaignId: campaignId,
          campaignCode: campaign.campaignCode,
          campaignName: campaign.name,
          category: campaign.category,
          openTime: this.Utc2UnixTime(campaign.openAt),
          closedTime: this.Utc2UnixTime(campaign.closedAt),
          startTime: this.Utc2UnixTime(campaign.startAt),
          endTime: this.Utc2UnixTime(campaign.endAt),
          couponNum: campaign.couponCount,
          confirmedCouponCount: 0,
          isShow: true,
          isUnlimited: campaign.isUnlimited,
          limits: campaign.limits,
          systemInfo: campaign.systemInfo,
          isDownloading: false,
          isProcessing: false,
          scenarioDocId: campaign.scenarioDocId,
          isDynamic: campaign.isDynamic,
          packageCode: packageCode,
          packageId: packageId || "",
          packageIndex: packageIndex,
        });
      }
    },

    fixCampaignlessPackages() {
      Object.entries(this.packageData).forEach(([packageId, packageData]) => {
        if (packageData.campaignIds.length !== 0) {
          return;
        }

        this.campaignData.push({
          packageCode: this.getPackageCode(packageData),
          packageId: packageId,
          packageIndex: 0,
          campaignCode: "",
          campaignName: "",
          category: "",
          openTime: 0,
          closedTime: 0,
          startTime: 0,
          endTime: 0,
          couponNum: 0,
          confirmedCouponCount: 0,
          isShow: false,
          isUnlimited: false,
          limits: 0,
          systemInfo: {},
          isDownloading: false,
          isProcessing: false,
          scenarioDocId: "",
          isDynamic: false,
          customerCode: "",
          customerId: "",
          campaignId: "",
        });
      });
    },

    getPackageCode(packageData?: {
      name: string;
      code: string;
      campaignIds: string[];
    }) {
      if (!packageData) {
        return "\u{10FFFF}";
      }
      return `${packageData.name} (${packageData.code})`;
    },

    getPackageIndex(
      campaignId: string,
      packageData?: {
        campaignIds: string[];
        name: string;
        code: string;
      },
    ) {
      if (!packageData || !packageData.campaignIds.length) {
        return 0;
      }
      return packageData.campaignIds.indexOf(campaignId);
    },

    async loadConfirmedCouponCount() {
      const confirmedCouponCountsArray =
        await campaignService.getConfirmedCouponCounts(
          this.campaignData.map((c) => c.campaignId),
        );

      const confirmedCouponCounts = confirmedCouponCountsArray.reduce(
        (acc, item) => {
          acc[item.campaignId] = item.confirmedCount;
          return acc;
        },
        {} as Record<string, number>,
      );

      this.campaignData.forEach((campaign) => {
        campaign.confirmedCouponCount =
          confirmedCouponCounts[campaign.campaignId] || 0;
      });
    },

    /**
     * Utility Methods for Date/Time Handling
     */
    Utc2UnixTime(dateString: DateOrTimestamp | null) {
      if (dateString === null) {
        return 0;
      }
      if (typeof dateString === "number") {
        return new Date(dateString * 1000).getTime();
      } else {
        return new Date(dateString).getTime();
      }
      // timezoneをZ(UTC)と指定してunixTimeを取得
    },

    UnixTimeToString(UnixTime: number) {
      return moment(UnixTime).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
    },

    /**
     * Campaign Results Management Methods
     */

    /**
     * Utility Methods for Web App URL
     */
    getWebAppUrl(): string {
      if (process.env.VUE_APP_LEARNER_WEBAPP_URL) {
        return process.env.VUE_APP_LEARNER_WEBAPP_URL;
      }

      const currentOrigin = window.location.origin;
      return currentOrigin.replace("customer-console", "speaking");
    },

    /**
     * Data Export Methods
     */
    downloadBtnAction(campaignId: string) {
      for (const item of this.campaignData) {
        if (item.campaignId === campaignId) {
          if (item.isProcessing) {
            break;
          } else {
            item.isDownloading = true;
            item.isProcessing = true;
            this.downloadData(campaignId).then(() => {
              setTimeout(() => {
                item.isDownloading = false;
                item.isProcessing = false;
              }, 500);
            });
          }
          break;
        }
      }
    },
    // csv変換を加えたDL機能
    async downloadData(campaignId: string) {
      try {
        console.log(
          "🚀 Using OPTIMIZED CSV download for campaign:",
          campaignId,
        );
        const campaignResults =
          await campaignService.getCampaignResults(campaignId);

        const dialogs =
          campaignResults?.flatMap((result) => result.dialogs) || [];

        if (dialogs && dialogs.length > 0) {
          const campaign = await campaignService.getByIdOrCode(campaignId);
          this.downloadForCsv(dialogs, campaign);
        } else {
          console.log("⚠️ No dialogs found, showing empty CSV");
          downloadNoDialogAssessmentCsv();
        }
      } catch (error) {
        console.error("❌ Failed to download CSV data:", error);
        downloadNoDialogAssessmentCsv();
      }
    },

    downloadForCsv(
      dialogs: DialogWithRelations[],
      campaign: CampaignWithId | null,
    ) {
      const langxWebAppUrl = this.getWebAppUrl();

      const headers = [
        "CampaignCode",
        "TicketId",
        "Started At",
        "Completed At",
        "Reviews",
        "CEFR Level",
        "CEFR Score",
        "Accuracy Level",
        "Accuracy Score",
        "Coherence Level",
        "Coherence Score",
        "Fluency Level",
        "Fluency Score",
        "Interaction Level",
        "Interaction Score",
        "Phonology Level",
        "Phonology Score",
        "Range Level",
        "Range Score",
        "channelName",
        "Link to shared report page",
      ];

      // Transform dialog data directly to CSV format - NO API CALLS NEEDED!
      const rows = dialogs
        .map((dialog) => {
          const cefrResults: CefrResults =
            dialog.assessment?.assessmentData?.cefrResults ||
            ({} as CefrResults);
          const ticket = dialog.ticket;
          if (!ticket) {
            return null;
          }

          const getCefrLabel = (scoreData: {
            cefrLevel?: string;
            label?: string;
          }) => {
            if (!scoreData) return "";
            return scoreData.label || scoreData.cefrLevel || "";
          };

          const getCefrScore = (scoreData: { score?: number | string }) => {
            if (!scoreData || scoreData.score === undefined) return "";
            const numericScore = Number(scoreData.score);
            if (isNaN(numericScore)) return "";
            return roundToTwoDecimals(numericScore);
          };

          const interactionLevel =
            cefrResults.interaction?.score === -1
              ? String(this.$t("conversationAnalysis.unrated"))
              : getCefrLabel(cefrResults.interaction);
          const interactionScore =
            cefrResults.interaction?.score === -1
              ? ""
              : getCefrScore(cefrResults.interaction);

          const reviews = getReviewPracticeCount(dialog) || "";

          return [
            campaign?.campaignCode || "",
            ticket?.customerOptions?.couponCode || "N/A",
            this.UnixTimeToString(this.Utc2UnixTime(dialog.startedAt)),
            this.UnixTimeToString(this.Utc2UnixTime(dialog.endedAt)),
            forceCsvText(reviews),
            getCefrLabel(cefrResults.overall),
            String(getCefrScore(cefrResults.overall)),
            getCefrLabel(cefrResults.accuracy),
            String(getCefrScore(cefrResults.accuracy)),
            getCefrLabel(cefrResults.coherence),
            String(getCefrScore(cefrResults.coherence)),
            getCefrLabel(cefrResults.fluency),
            String(getCefrScore(cefrResults.fluency)),
            interactionLevel,
            String(interactionScore),
            getCefrLabel(cefrResults.phonology),
            String(getCefrScore(cefrResults.phonology)),
            getCefrLabel(cefrResults.range),
            String(getCefrScore(cefrResults.range)),
            dialog.id || "",
            dialog.assessment
              ? `${langxWebAppUrl}/shared-report/${dialog.id}`
              : "",
            ...getCanDoScores(dialog).map(String),
          ];
        })
        .filter((row): row is string[] => row !== null);

      const maxCanDos = Math.max(
        0,
        ...rows.map((row) => row.length - headers.length),
      );
      const allHeaders = [
        ...headers,
        ...Array.from({ length: maxCanDos }, (_, i) => `Can Do ${i + 1}`),
      ];
      const paddedRows = rows.map((row) =>
        allHeaders.map((_, i) => row[i] ?? ""),
      );

      const csvContent = createCsvContent(paddedRows, allHeaders);
      downloadCsv(csvContent, `exportData_${getJstTimestamp()}.csv`);
    },

    /**
     * UI State Management Methods
     */
    closeSnackbar() {
      this.snackbarActionBtn = false;
      this.snackbarActionButtonText = "";
      this.snackbarActionButtonRoute = "";
      this.snackbarScrollToSelector = "";
      this.snackbarEditCampaignCode = "";
    },

    showSnackbar({
      message,
      color,
      actionButtonText,
      actionButtonRoute,
      scrollToSelector,
      editCampaignCode,
    }: {
      message: string;
      color?: string;
      actionButtonText?: string;
      actionButtonRoute?: string;
      scrollToSelector?: string;
      editCampaignCode?: string;
    }) {
      // Force a close-then-open cycle so the snackbar prop watcher fires
      // and the timer/content refresh even if a previous snackbar is still visible
      this.snackbarActionBtn = false;
      this.$nextTick(() => {
        this.snackbarTextField = message;
        this.snackbarColorField = color ?? "pink";
        this.snackbarActionButtonText = actionButtonText ?? "";
        this.snackbarActionButtonRoute = actionButtonRoute ?? "";
        this.snackbarScrollToSelector = scrollToSelector ?? "";
        this.snackbarEditCampaignCode = editCampaignCode ?? "";
        this.snackbarActionBtn = true;
      });
    },

    async onSnackbarActionButtonClick() {
      const editCode = this.snackbarEditCampaignCode;
      const scrollSelector = this.snackbarScrollToSelector;
      const route = this.snackbarActionButtonRoute;
      this.closeSnackbar();

      if (editCode) {
        let item = this.campaignData.find((c) => c.campaignCode === editCode);
        if (!item) {
          await this.readData();
          item = this.campaignData.find((c) => c.campaignCode === editCode);
        }
        if (item) {
          this.editItemHasCouponError = true;
          this.editItem(item);
        }
      } else if (scrollSelector) {
        await this.scrollToElement(scrollSelector);
      } else if (route) {
        this.$router.push(route);
      }
    },

    async scrollToElement(selector: string) {
      // Wait for any in-progress data loading to finish
      if (this.isLoadingCampaigns) {
        await new Promise<void>((resolve) => {
          const unwatch = this.$watch("isLoadingCampaigns", (val: boolean) => {
            if (!val) {
              unwatch();
              resolve();
            }
          });
        });
      }

      // Ensure DOM is updated after data load
      await this.$nextTick();
      let el = document.querySelector(selector);

      // If still not found, force a fresh data load
      if (!el) {
        await this.readData();
        await this.$nextTick();
        el = document.querySelector(selector);
      }

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        const row = el.closest("tr") ?? el;
        row.classList.add("highlight-row");
        setTimeout(() => row.classList.remove("highlight-row"), 2000);
      }
    },

    getShowingCampaignCount(items: HomeCampaignType[]) {
      const count = items.filter((item) => item.isShow).length;
      return this.$tc("home.campaignCount", count, { count });
    },

    getHeaders(): TableHeader[] {
      return [
        {
          text: "",
          value: "packageCode",
          align: "center",
          sortable: true,
          groupable: true,
        },
        {
          text: "#",
          value: "packageIndex",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.campaignCodeOrName") as string,
          value: "campaignCode",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.publicPeriod") as string,
          value: "openTime",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.examPeriod") as string,
          value: "startTime",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.couponCounts") as string,
          value: "couponCounts",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.interviewCountPerCoupon") as string,
          value: "interviewCountPerCoupon",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.edit") as string,
          value: "edit",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.couponList") as string,
          value: "couponList",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.showResults") as string,
          value: "showResults",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.distribution") as string,
          value: "showResults",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: this.$t("home.tableHeader.download") as string,
          value: "download",
          align: "start",
          sortable: false,
          groupable: false,
        },
      ];
    },

    updateHeaders() {
      this.headers = this.getHeaders();
    },

    /**
     * Coupon Dialog Management Methods
     */
    openCampaignCouponList(campaignId: string) {
      this.couponDialogCollection = "campaigns";
      this.couponDialogId = campaignId;
      this.isCouponDialogVisible = true;
    },

    openPackageCouponList(packageId: string) {
      this.couponDialogCollection = "packages";
      this.couponDialogId = packageId;
      this.isCouponDialogVisible = true;
    },

    resetCouponDialogState() {
      this.couponDialogId = null as null | string;
      this.couponDialogCollection = null as null | "campaigns" | "packages";
    },

    async handleCouponListChange(payload: { hasDeleteOccurred: boolean }) {
      if (this.couponDialogCollection === "campaigns" && this.couponDialogId) {
        await this.updateCampaignsCouponCounts(
          [this.couponDialogId],
          payload.hasDeleteOccurred,
        );
      } else if (
        this.couponDialogCollection === "packages" &&
        this.couponDialogId
      ) {
        const packageInfo = this.packageData[this.couponDialogId];
        if (packageInfo?.campaignIds?.length) {
          await this.updateCampaignsCouponCounts(
            packageInfo.campaignIds,
            payload.hasDeleteOccurred,
          );
        }
      }
    },

    async updateCampaignsCouponCounts(
      campaignIds: string[],
      hasDeleteOccurred: boolean,
    ) {
      if (hasDeleteOccurred) {
        await Promise.all(
          campaignIds.map(async (campaignId) => {
            const campaignData = this.campaignData.find(
              (c) => c.campaignId === campaignId,
            );
            if (!campaignData) return;

            const campaign = await campaignService.getByIdOrCode(campaignId);
            if (campaign) {
              campaignData.couponNum = campaign.couponCount;
            }
          }),
        );
      }

      const confirmedCounts =
        await campaignService.getConfirmedCouponCounts(campaignIds);

      const countsMap = confirmedCounts.reduce(
        (acc, item) => {
          acc[item.campaignId] = item.confirmedCount;
          return acc;
        },
        {} as Record<string, number>,
      );

      campaignIds.forEach((campaignId) => {
        const campaignData = this.campaignData.find(
          (c) => c.campaignId === campaignId,
        );
        if (campaignData) {
          campaignData.confirmedCouponCount = countsMap[campaignId] || 0;
        }
      });
    },

    getPeriodLabel(
      key: string,
      specifyKey: string,
      start: number,
      end: number,
      translationBase: string,
    ): string {
      if (!key || key === "all" || key === "noFilter") return "";
      if (key === specifyKey && (start !== 0 || end !== 0)) {
        return `${this.$t(
          `${translationBase}.${specifyKey}`,
        )} (${this.UnixTimeToString(start)}) 〜 (${this.UnixTimeToString(end)})`;
      }
      return String(this.$t(`${translationBase}.${key}`));
    },

    /**
     * Distribution Management Methods
     */
    openDistributionDialog(packageId: string) {
      this.distributionPackage =
        this.rawPackages.find((p) => p.id === packageId) || null;
      this.isDistributionDialogVisible = true;
    },

    handleDistributionSeeTickets(payload: { packageId: string }) {
      this.openPackageCouponList(payload.packageId);
    },
  },
});
</script>
